module.exports = __webpack_public_path__ + "static/media/ICBT Jockey Pulley-.a45d72f6.jpg";